import { render, staticRenderFns } from "./TopFlopThemesDashboard.vue?vue&type=template&id=5b818995&scoped=true&"
import script from "./TopFlopThemesDashboard.vue?vue&type=script&lang=js&"
export * from "./TopFlopThemesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TopFlopThemesDashboard.vue?vue&type=style&index=0&id=5b818995&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b818995",
  null
  
)

export default component.exports